module.exports = __webpack_public_path__ + "img/hand-index.7aec49c4.svg";